@if (showDataset) {
  <!------------------------------

      Template Dataset Display

  ------------------------------->
  <!------------------------------

      Table wrapper

  ------------------------------->
  <sb-table-wrapper
    [isInModalContext]="true"
    [headline]="'lang.globals.templateDataset' | translate"
    [itemsData]="templateDatasets"
    (filterChange)="requestDebounced()" [options]="options" (optionsChange)="requestDebounced($event)"
    [loading]="loading" [itemName]="'datasets'" [showExactMatch]="true">

    <!------------------------------

          Table Header

    ------------------------------->
    <ng-template #thead>
      <tr>
        <th>
          {{ 'lang.globals.id' | translate }}
        </th>
        <th>
          {{ 'lang.globals.name' | translate }}
        </th>
        <th>
          {{ 'lang.globals.templateGroup' | translate }}
        </th>
        <th></th>
      </tr>
    </ng-template>
    <!------------------------------

  Table Body

  ------------------------------->
    <ng-template #tbody let-templateDataset>
      <tr>
        <td>
          {{ templateDataset?.id }}
        </td>
        <td>
          {{ templateDataset?.name }}
        </td>
        <td>
          {{ templateDataset?.group?.name }}
        </td>
        <td class="text-right sticky-col last-col tableBg">
          <button sb-button-secondary icon="diveDeeper" type="button" color="blue" [iconButton]="true" class=""
                  (click)="showDatasetEntries(templateDataset)">
          </button>
          <a class="btn btn-hover-primary tw-ml-3" (click)="selectTemplateDataset(templateDataset)">
            <sb-icon icon="selection"></sb-icon>
          </a>
        </td>
      </tr>
    </ng-template>

    <div footer-more class="d-flex">
      <button
        (click)="cancel()"
        class="ml-auto btn btn-danger btn-sm"
        style="position: absolute; right: 2rem; margin-top: -3.5rem;">
        {{ 'lang.globals.cancel' | translate }}
      </button>
    </div>

    <!------------------------------

      Card Element

  ------------------------------->
    <!-- No card element -->

  </sb-table-wrapper>

} @else {

  <!------------------------------

      Template DatasetEntry display

  ------------------------------->
    <!------------------------------

        Table wrapper

    ------------------------------->
  <sb-table-wrapper
    [isInModalContext]="true"
    [headline]="('lang.globals.templateDatasetEntries' | translate) +' ' + ('lang.globals.from' | translate) + ' \'\'' + selectedDataSet?.name + '\'\''"
    [itemsData]="templateDatasetEntries"
    (filterChange)="requestDebouncedEntries()" [options]="optionsEntries" (optionsChange)="requestDebouncedEntries($event)"
    [loading]="loading" [itemName]="'templateDatasetEntries'" [showExactMatch]="true">

    <!------------------------------

          Header more

    ------------------------------->
    <div header-more>
      <button sb-button-primary type="button" color="blue" icon="arrowLeft"
              (click)="showDataset = true; selectedDataSet = null; templateDatasetEntries= []; loading= true">
        {{ 'lang.globals.back' | translate }}
      </button>
    </div>

    <!------------------------------

          Table Header

    ------------------------------->
    <ng-template #thead>
      <tr>
        <th>
          {{ 'lang.globals.id' | translate }}
        </th>
        <th>
          {{ 'lang.globals.name' | translate }}
        </th>
        <th></th>
      </tr>
    </ng-template>
    <!------------------------------

  Table Body

  ------------------------------->
    <ng-template #tbody let-templateDatasetEntry>
      <tr>
        <td>
          {{ templateDatasetEntry?.id }}
        </td>
        <td>
          {{ templateDatasetEntry?.name }}
        </td>
        <td class="text-right sticky-col last-col tableBg">
          <a class="btn btn-hover-primary" (click)="selectTemplateDatasetEntry(templateDatasetEntry)">
            <sb-icon icon="selection"></sb-icon>
          </a>
        </td>
      </tr>
    </ng-template>

    <div footer-more class="d-flex">
      <button
        (click)="cancel()"
        class="ml-auto btn btn-danger btn-sm"
        style="position: absolute; right: 2rem; margin-top: -3.5rem;">
        {{ 'lang.globals.cancel' | translate }}
      </button>
    </div>

    <!------------------------------

      Card Element

  ------------------------------->
    <!-- No card element -->

  </sb-table-wrapper>
}
